import { Plugin } from '../../types';
export const delay = (t) => new Promise(r => setTimeout(r, t))
export const screenshot: Plugin = {
  name: 'screenshot',
  page: (emit) => {
    window.document.addEventListener('keypress', (e) => {
      const now = Date.now()
      if(e.shiftKey && e.ctrlKey && e.code === 'KeyS'){
        emit({ name: 'screenshot', time: now })
      }
    });
  },
  test: {
    matchers: {
      async toMatchImageSnapshot(page, snapshotOptions) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        await page.waitForLoadState('networkidle')
        await page.waitForLoadState('domcontentloaded')
        await delay(1000)
        const { configureToMatchImageSnapshot } = require('jest-image-snapshot')
        const toMatchImageSnapshot = configureToMatchImageSnapshot({
          // customDiffConfig: customConfig,
          noColors: true,
          failureThreshold: 5,
          failureThresholdType: 'percent',
        });
        await page.waitForLoadState("domcontentloaded");
        const image = await page.screenshot({ fullPage: true, ...snapshotOptions});
        const boundImageSnapshot = toMatchImageSnapshot.bind(this);
        return boundImageSnapshot(image);
      }
    }
  },
  generate(event) {
    if (event.name === 'screenshot') {
      return `
      it("matches image snapshot", async()=>{
        await expect(page).toMatchImageSnapshot();
      })
    `
    }
    return ''
  }
}
export default screenshot